<div class="image-container" style="direction: ltr">
  <img
    class="img-fluid"
    style="width: 330px; width: calc(var(--scroll-item-width) - 10px); max-width: 100%;"
    [src]="getPictureUrl"
    alt="credit card image"
  />
  <p class="cardNumber" sensitive-data>
    <span *ngIf="_cardNumber">{{ _cardNumber }}</span>
  </p>
  <p class="holderName" style="text-transform: uppercase" sensitive-data>
    <span *ngIf="holderName">{{ holderName }}</span>
  </p>
  <p class="expiryDate" *ngIf="_expiryDate" sensitive-data>{{ _expiryDate }}</p>
  <p class="cvc" *ngIf="cvc" sensitive-data>
    <span>CVC</span>
    <span>{{ cvc }}</span>
  </p>
  <div class="activate-card" *ngIf="Status == 'Freeze'"></div>
  <div class="inActive" *ngIf="Status == 'Inactive' || forceActivation">
    <button
      type="button"
      class="button button-primary"
      (click)="startActivation()"
    >
      <span>{{"CreditCard.Buttons.ActivateCard" | translate}}</span>
    </button>
    <!-- <button type="button">
      <img
        src="assets/images/warn.svg"
        alt="card blocked"
        style="width: 30px"
      />
      <span>{{ StatusDisplay }}</span>
    </button> -->
  </div>
  <div class="card-blocked" *ngIf="Status == 'Blocked'">
    <button type="button">
      <img
        src="assets/images/block.svg"
        class="filter-red"
        alt="card blocked"
      />
      <!-- <span>{{ "CreditCard.Cardisblocked" | translate }}</span> -->
      <span> {{ StatusDisplay }}</span>
    </button>
  </div>
</div>
